import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import ReactAudioPlayer from 'react-audio-player';
import Iconify from 'src/components/iconify';
import PropTypes from 'prop-types';

export default function FilesPreview({ files, setFiles, mode }) {
  // functions
  const downloadFile = file => {
    if (file) {
      let url = '';

      if (typeof file === 'string') {
        url = file;
      } else {
        url = URL.createObjectURL(file);
      }

      const link = document.createElement('a');
      link.href = url;
      link.download = file.name;
      link.click();
      URL.revokeObjectURL(url);
    }
  };

  const removeFile = index => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);
  };

  return (
    <Stack spacing="8px">
      {files && files.length
        ? files.map((file, index) => {
            const isAudioFile =
              typeof file === 'string'
                ? file.endsWith('.mp3') ||
                  file.endsWith('.wav') ||
                  file.endsWith('.ogg')
                : file.type.startsWith('audio/');

            return (
              <Stack
                key={index}
                width="300px"
                sx={{
                  borderRadius: '3px',
                  bgcolor: 'background.primaryGrey2',
                  color: 'content.primaryGrey2',
                }}
              >
                <Stack
                  direction="row"
                  spacing="8px"
                  alignItems="center"
                  p="8px"
                >
                  <Iconify icon="tabler:file-text" />
                  <Tooltip title={typeof file === 'string' ? file : file.name}>
                    <Typography
                      variant="input"
                      lineHeight="normal"
                      color="content.primaryBlack2"
                      sx={{
                        width: '160px',
                        maxWidth: '160px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        color: 'content.primaryGrey2',
                      }}
                    >
                      {typeof file === 'string' ? file : file.name}
                    </Typography>
                  </Tooltip>
                  <Stack sx={{ flexGrow: 1 }} />
                  <IconButton onClick={() => downloadFile(file)}>
                    <Iconify icon="tabler:download" />
                  </IconButton>
                  {mode !== 'VIEW' && (
                    <IconButton onClick={() => removeFile(index)}>
                      <Iconify icon="tabler:x" />
                    </IconButton>
                  )}
                </Stack>
                <Stack paddingRight="4px">
                  {isAudioFile ? (
                    <ReactAudioPlayer
                      src={
                        typeof file === 'string'
                          ? file
                          : URL.createObjectURL(file)
                      }
                      style={{
                        width: '100%',
                        height: '40px',
                        backgroundColor: '#F5F1FF',
                        color: '#5418EF',
                      }}
                      controls
                    />
                  ) : null}
                </Stack>
              </Stack>
            );
          })
        : null}
    </Stack>
  );
}

FilesPreview.propTypes = {
  files: PropTypes.object,
  setFiles: PropTypes.func,
  mode: PropTypes.string,
};
